





































import { Vue, Component, Watch } from 'vue-property-decorator';
import ListItem from '../components/ListItem.vue';
import { Sticky, List } from 'vant';
import { getList } from '../api';
Vue.use(Sticky).use(List);
@Component({
  components: {
    ListItem,
  },
})
export default class Home extends Vue {
  keyword = '';
  page = 1;
  loading = false;
  finished = false;
  voteList: any[] = [];
  searchTimer: any = null;

  @Watch('keyword')
  onKeywordChange(newval: string) {
    if (!newval.length) {
      this.resetVoteList();
      this.onGetVoteList();
    }
  }

  created() {
    this.onGetVoteList();
  }

  async onGetVoteList() {
    this.loading = true;
    const ret = await getList(this.page, this.keyword);
    this.loading = false;
    if (!ret.data.length) {
      this.finished = true;
    } else {
      this.voteList = [...this.voteList, ...ret.data];
      this.page++;
    }
  }

  resetVoteList() {
    this.voteList = [];
    this.finished = false;
    this.page = 1;
  }
  onSearch() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
    this.searchTimer = setTimeout(() => {
      this.resetVoteList();
      this.onGetVoteList();
    }, 200);
  }

  onNavTo(item: any, index: number) {
    this.$router.push(`Detail?id=${item.id}`);
  }
}
